import ReactQuill from "react-quill";
import styled from "styled-components";
import {
  BodyCaption,
  BodySecondary,
  COLORS,
} from "@bikdotai/bik-component-library";

export const AttachmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${COLORS.surface.subdued};
  margin-bottom: 4px;
  margin-top: 4px;
  padding: 7px;
  width: 200px;
  align-items: center;
  border-radius: 8px;
`;

export const ProgressIndicatorContainer = styled.div`
  flex: 1;
  flex-direction: row;
  align-items: center;
`;

export const OuterProgressBarContainer = styled.div`
  height: 8px;
  border-radius: 8px;
  background-color: ${COLORS.background.inactive};
  flex: 1;
`;

export const InnerProgressBarContainer = styled.div`
  height: 100%;
  border-radius: 4px;
`;

export const AttachmentName = styled(BodyCaption)`
  color: ${COLORS.content.brand};
  width: 50%;
`;

export const ForwardMessageContainer = styled.div`
  padding: 8px;
  border-radius: 4px;
  margin: 0 8px 6px 8px;
  background-color: ${COLORS.background.warning.light};
`;

export const StyledBodySecondary = styled(BodySecondary)`
  color: ${COLORS.content.warning};
  font-style: italic;
`;

export const LeftItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InboxIconContainer = styled.div<{
  isSelected?: boolean;
  selectedBgColor?: string;
}>`
  cursor: pointer;
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: ${(props) =>
    props.isSelected
      ? (props.selectedBgColor ?? COLORS.background.positive.light)
      : COLORS.surface.standard};
  &:hover {
    background-color: ${(props) =>
      props.isSelected
        ? (props.selectedBgColor ?? COLORS.background.positive.light)
        : COLORS.surface.hovered};
  }
`;

export const SendConatiner = styled.div<{ isModalView: boolean }>`
  display: flex;
  flex-direction: row;
  padding: ${(props) => (props.isModalView ? "6px 12px" : "12px 8px 8px 8px ")};
  border-width: 0px;
  border-top-width: 0.5px;
  border-style: solid;
  border-color: ${COLORS.background.inactive};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 100%;
  height: 44px;
  align-items: center;

  justify-content: space-between;
`;
export const ReactQuilStyleContainer = styled(ReactQuill)<{
  isModalView: boolean;
}>`
  width: 100%;
  height: ${(props) => (props.isModalView ? "260" : "130")}px;
  .ql-container.ql-snow {
    width: 100%;
    border: 0px;
  }
  .ql-editor {
    padding: 0px;

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 20px;
    }
  }
  .ql-editor::-webkit-scrollbar {
    width: 8px;
    display: block;
    border-radius: 20px;
  }
  .ql-editor.ql-blank::before {
    font-style: normal;
    color: ${COLORS.content.placeholder};
  }
  a {
    color: ${COLORS.content.brand} !important;
    cursor: pointer !important;
    text-decoration: underline !important;
  }
`;

export const EditorContainer = styled.div<{ isModalView: boolean }>`
  width: 100%;
  max-height: ${(props) => (props.isModalView ? "320px" : "30vh")};
  min-height: ${(props) => (props.isModalView ? "320px" : "20vh")};
  padding: ${(props) => (props.isModalView ? "24px 12px" : "0px")};
  display: flex;
  flex-direction: column;

  .attachment__container {
    display: flex;
    gap: 6px;
    margin: 0 6px;
    overflow-x: scroll;
    max-width: 100%;
    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }
    &::-webkit-scrollbar {
      height: 6px;
      display: block;
    }
  }
`;

export const EmailAttachmentContainer = styled.div`
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap to the next line */
  gap: 6px;
  margin: 0 6px;
  overflow-x: hidden; /* Disable horizontal scrolling */
  max-width: 100%;
  justify-content: flex-start;
  & > * {
    flex: 1 1 calc(20% - 6px); /* Each attachment takes up 20% of the width, minus the gap */
    max-width: calc(20% - 6px); /* Ensure max width respects 5 per row */
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }
  &::-webkit-scrollbar {
    height: 6px;
    display: block;
  }
`;

export const EditorInnerContainer = styled.div<{ isModalView: boolean }>`
  min-height: 40px;
  flex-grow: 1;
  padding: ${(props) => (props.isModalView ? "0px" : "8px")};
`;
